import {
  Button,
  Col,
  Form,
  Image,
  Input,
  InputNumber,
  Modal,
  Row,
  Select,
  Space,
  Table,
  Upload,
  Alert,
  Card,
  Tag,
  Tooltip,
  Divider,
} from "antd";
import { useEffect, useState } from "react";
import {
  EditOutlined,
  DeleteOutlined,
  PlusOutlined,
  SearchOutlined,
  GiftOutlined,
  EyeOutlined,
  ReloadOutlined,
  MinusCircleOutlined,
} from "@ant-design/icons";
import { apiCall } from "../../API/RestApi";
import Search from "antd/es/input/Search";
import { useSelector } from "react-redux";

function ListPrizeCategory() {
  const token = useSelector((state) => state.user.token);

  const [form] = Form.useForm();

  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [isAlert, setIsAlert] = useState(false);
  const [textAlert, setTextAlert] = useState("");

  const [search, setSearch] = useState("");
  const [filterStatus, setFilterStatus] = useState("true");

  const [isModal, setIsModal] = useState(false);
  const [dataModal, setDataModal] = useState(null);

  const [isDetailModal, setIsDetailModal] = useState(false);
  const [detailData, setDetailData] = useState(null);

  const [fileImages, setFileImages] = useState({});
  const [imagePreviews, setImagePreviews] = useState({});

  const [outlets, setOutlets] = useState([]);
  const [isPrizeModal, setIsPrizeModal] = useState(false);
  const [editingPrizeIndex, setEditingPrizeIndex] = useState(null);
  const [prizeForm] = Form.useForm();

  const [page, setPage] = useState({
    pagination: {
      current: 1,
      pageSize: 10,
    },
  });

  useEffect(() => {
    getData();
    getOutlet();
  }, [JSON.stringify(page), search, filterStatus]);

  const getOutlet = () => {
    apiCall({
      method: "GET",
      url: "/pos/outlet?page=1&limit=999",
      data: {
        headers: {
          Authorization: "Bearer " + token,
        },
      },
    })
      .then((res) => {
        if (res.status === 200) {
          setOutlets(res.data.rows || []);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const getData = () => {
    setLoading(true);

    let url = `/prize-category?search=${search}`;

    if (filterStatus !== "") {
      url += `&status=${filterStatus}`;
    }

    apiCall({
      method: "GET",
      url,
      data: {
        headers: {
          Authorization: "Bearer " + token,
        },
      },
    })
      .then((res) => {
        if (res.status === 200) {
          const rows = Array.isArray(res.data) ? res.data : res.data.rows || [];

          setData(rows);

          setPage({
            ...page,
            pagination: {
              ...page.pagination,
              total: rows.length,
            },
          });
        }

        setLoading(false);
      })
      .catch((e) => {
        console.log(e);
        setLoading(false);
      });
  };

  const openModal = (type, record = null) => {
    setDataModal(null);
    setFileImages({});
    setImagePreviews({});
    form.resetFields();

    if (type === "edit") {
      setDataModal(record);

      const previews = {};
      const prizes = (record.prizes || record.Prizes || []).map((item, index) => {
        previews[index] = item.image;

        return {
          prize_id: item.prize_id,
          name: item.name,
          description: item.description || "",
          stock: Number(item.stock || 0),
          price: Number(item.price || 0),
          probability: Number(item.probability || 0),
          is_active: String(item.is_active),
          outlets: (item.prize_outlets || item.PrizeOutlets || []).map(
            (outlet) => Number(outlet.outlet_id)
          ),
        };
      });

      setImagePreviews(previews);

      const firstPrize = record.prizes?.[0] || record.Prizes?.[0];

      const categoryOutlets = (
        firstPrize?.prize_outlets ||
        firstPrize?.PrizeOutlets ||
        []
      ).map((outlet) => Number(outlet.outlet_id));

      form.setFieldsValue({
        name: record.name,
        description: record.description || "",
        is_active: String(record.is_active),
        outlets: categoryOutlets,
        prizes,
      });
    } else {
      form.setFieldsValue({
        is_active: "true",
        prizes: [
          {
            name: "",
            description: "",
            stock: 0,
            price: 0,
            probability: 0.01,
            is_active: "true",
            outlets: [],
          },
        ],
      });
    }

    setIsModal(true);
  };

  const closeModal = () => {
    setIsModal(false);
    setDataModal(null);
    setFileImages({});
    setImagePreviews({});
    form.resetFields();
  };

  const uploadImage = (info, index) => {
    const file = info.file;

    setFileImages((prev) => ({
      ...prev,
      [index]: file,
    }));

    const reader = new FileReader();
    reader.onload = () => {
      setImagePreviews((prev) => ({
        ...prev,
        [index]: reader.result,
      }));
    };
    reader.readAsDataURL(file);
  };

  const openDetail = (record) => {
    setDetailData(record);
    setIsDetailModal(true);
  };

  const modalDeleteData = (record) => {
    Modal.confirm({
      title: "NOTICE",
      content: `Anda ingin menghapus category "${record.name}" beserta semua prize?`,
      okText: "Hapus",
      cancelText: "Batal",
      onOk: () => postApi("DELETE", record),
    });
  };

  const postApi = (method, values) => {
    setLoading(true);

    let url = "/prize-category";

    if (method === "PUT") {
      url = "/prize-category/" + dataModal.prize_category_id;
    }

    if (method === "DELETE") {
      url = "/prize-category/" + values.prize_category_id;
    }

    apiCall({
      method,
      url,
      data: {
        data: values,
        headers: {
          Authorization: "Bearer " + token,
        },
      },
    })
      .then((res) => {
        setLoading(false);

        if (res.status === 200) {
          setIsAlert(true);
          setTextAlert(res.message || "Data berhasil disimpan");
          closeModal();
          getData();
        } else {
          Modal.error({
            title: "Gagal",
            content: res.message,
          });
        }
      })
      .catch((e) => {
        console.log(e);
        setLoading(false);
      });
  };

  const onFinish = (values) => {
    const formData = new FormData();

    formData.append("name", values.name);
    formData.append("description", values.description || "");
    formData.append("is_active", values.is_active);

    const outlets = (values.outlets || []).map((id) => Number(id));
    const rawPrizes = form.getFieldValue("prizes") || [];

    if (rawPrizes.length < 1) {
      Modal.error({
        title: "Prize wajib",
        content: "Prizes wajib diisi minimal 1",
      });
      return;
    }

    const prizes = rawPrizes.map((item, index) => {
      const imageField = `image_${index}`;

      const payload = {
        prize_id: item.prize_id || undefined,
        name: item.name,
        description: item.description || "",
        stock: item.stock || 0,
        price: item.price || 0,
        probability: item.probability || 0,
        is_active: item.is_active,
        outlets,
      };

      if (fileImages[index]) {
        payload.image_field = imageField;
        formData.append(imageField, fileImages[index]);
      }

      return payload;
    });

    for (let i = 0; i < prizes.length; i++) {
      if (!dataModal && !fileImages[i]) {
        Modal.error({
          title: "Gambar wajib",
          content: `Gambar prize ke-${i + 1} wajib diupload`,
        });
        return;
      }
    }
    formData.append("prizes", JSON.stringify(prizes));

    if (dataModal) {
      postApi("PUT", formData);
    } else {
      postApi("POST", formData);
    }
  };

  const handleTableChange = (pagination, filters, sorter) => {
    setPage({
      pagination,
      filters,
      ...sorter,
    });
  };

  const searchData = (value) => {
    setSearch(value);
    setPage({
      pagination: {
        current: 1,
        pageSize: 10,
      },
    });
  };

  const resetFilter = () => {
    setSearch("");
    setFilterStatus("true");
    setPage({
      pagination: {
        current: 1,
        pageSize: 10,
      },
    });
  };

  const uploadButton = (
    <div>
      <PlusOutlined />
      <div style={{ marginTop: 8 }}>Upload</div>
    </div>
  );

  const columns = [
    {
      title: "No",
      key: "no",
      width: 70,
      render: (_, __, index) =>
        (page.pagination.current - 1) * page.pagination.pageSize + index + 1,
    },
    {
      title: "Nama Category",
      dataIndex: "name",
      key: "name",
      render: (text) => <b>{text}</b>,
    },
    {
      title: "Deskripsi",
      dataIndex: "description",
      key: "description",
      render: (text) => text || "-",
    },
    {
      title: "Jumlah Prize",
      key: "total_prize",
      width: 140,
      render: (_, record) => {
        const prizes = record.prizes || record.Prizes || [];

        return <Tag color="blue">{prizes.length} Prize</Tag>;
      },
    },
    {
      title: "Status",
      dataIndex: "is_active",
      key: "is_active",
      width: 120,
      render: (text) =>
        text === true || text === "true" ? (
          <Tag color="green">Aktif</Tag>
        ) : (
          <Tag color="red">Nonaktif</Tag>
        ),
    },
    {
      title: "Action",
      key: "action",
      width: 220,
      fixed: "right",
      render: (_, record) => (
        <Space>
          <Tooltip title="Detail">
            <Button icon={<EyeOutlined />} onClick={() => openDetail(record)} />
          </Tooltip>

          <Tooltip title="Edit">
            <Button
              type="primary"
              icon={<EditOutlined />}
              onClick={() => openModal("edit", record)}
            />
          </Tooltip>

          <Tooltip title="Delete">
            <Button
              danger
              type="primary"
              icon={<DeleteOutlined />}
              onClick={() => modalDeleteData(record)}
            />
          </Tooltip>
        </Space>
      ),
    },
  ];

  const openPrizeDetail = (index) => {
    const prizes = form.getFieldValue("prizes") || [];
    const prize = prizes[index];

    setEditingPrizeIndex(index);
    prizeForm.setFieldsValue(prize);
    setIsPrizeModal(true);
  };

  const savePrizeDetail = () => {
    prizeForm.validateFields().then((values) => {
      const prizes = form.getFieldValue("prizes") || [];

      prizes[editingPrizeIndex] = {
        ...prizes[editingPrizeIndex],
        ...values,
      };

      form.setFieldsValue({ prizes });

      setIsPrizeModal(false);
      setEditingPrizeIndex(null);
      prizeForm.resetFields();
    });
  };

  const addPrize = () => {
    const prizes = form.getFieldValue("prizes") || [];

    const totalProbability = prizes.reduce(
      (sum, item) => sum + Number(item.probability || 0),
      0
    );

    if (totalProbability >= 100) {
      Modal.warning({
        title: "Probability penuh",
        content: "Total probability sudah mencapai 100%",
      });
      return;
    }

    form.setFieldValue("prizes", [
      ...prizes,
      {
        name: "",
        description: "",
        stock: 0,
        price: 0,
        probability: Number((100 - totalProbability).toFixed(2)),
        is_active: "true",
      },
    ]);
  };

  const removePrize = (index) => {
    const prizes = form.getFieldValue("prizes") || [];
    const newPrizes = prizes.filter((_, i) => i !== index);

    form.setFieldValue("prizes", newPrizes);
  };

  const getRemainingProbability = () => {
    const prizes = form.getFieldValue("prizes") || [];

    const total = prizes.reduce(
      (sum, item) => sum + Number(item.probability || 0),
      0
    );

    return 100 - total;
  };

  return (
    <>
      {isAlert && (
        <Alert
          message={textAlert}
          type="success"
          banner
          closable
          afterClose={() => setIsAlert(false)}
        />
      )}

      <Card
        title={
          <Space>
            <GiftOutlined />
            <b>Master Prize Category</b>
          </Space>
        }
        extra={
          <Button type="primary" onClick={() => openModal("add")}>
            <PlusOutlined /> Tambah Category
          </Button>
        }
      >
        <Row
          gutter={[12, 12]}
          style={{
            marginBottom: 16,
            justifyContent: "space-between",
          }}
        >
          <Space wrap>
            <Search
              placeholder="Cari category..."
              allowClear
              enterButton={<SearchOutlined />}
              onSearch={searchData}
              style={{ width: 240 }}
            />

            <Select
              style={{ width: 180 }}
              value={filterStatus}
              onChange={(value) => setFilterStatus(value)}
              options={[
                { value: "", label: "Semua Status" },
                { value: "true", label: "Aktif" },
                { value: "false", label: "Nonaktif" },
              ]}
            />
          </Space>

          <Space>
            <Tooltip title="Reset">
              <Button icon={<ReloadOutlined />} onClick={resetFilter} />
            </Tooltip>
          </Space>
        </Row>

        <Table
          rowKey="prize_category_id"
          columns={columns}
          dataSource={data}
          loading={loading}
          pagination={page.pagination}
          onChange={handleTableChange}
          scroll={{ x: 900 }}
        />
      </Card>

      <Modal
        title={dataModal ? "Ubah Prize Category" : "Tambah Prize Category"}
        open={isModal}
        onOk={form.submit}
        onCancel={closeModal}
        okText="Simpan"
        cancelText="Batal"
        width={1100}
        centered
      >
        <Form form={form} layout="vertical" onFinish={onFinish}>
          <Form.Item name="prizes" hidden>
            <Input />
          </Form.Item>
          <Card title="Informasi Category" style={{ marginBottom: 20 }}>
            <Row gutter={16}>
              <Col xs={24} md={12}>
                <Form.Item
                  name="name"
                  label="Nama Category"
                  rules={[{ required: true, message: "Nama category wajib diisi!" }]}
                >
                  <Input placeholder="Contoh: Voucher" />
                </Form.Item>
              </Col>

              <Col xs={24} md={12}>
                <Form.Item
                  name="is_active"
                  label="Status"
                  rules={[{ required: true, message: "Status wajib dipilih!" }]}
                >
                  <Select
                    options={[
                      { value: "true", label: "Aktif" },
                      { value: "false", label: "Nonaktif" },
                    ]}
                  />
                </Form.Item>
              </Col>

              <Col span={24}>
                <Form.Item name="description" label="Deskripsi Category">
                  <Input.TextArea rows={3} placeholder="Deskripsi category" />
                </Form.Item>
              </Col>

              <Col span={24}>
                <Form.Item
                  name="outlets"
                  label="Outlet"
                  rules={[{ required: true, message: "Outlet wajib diisi!" }]}
                >
                  <Select
                    mode="multiple"
                    showSearch
                    allowClear
                    placeholder="Pilih outlet untuk semua prize"
                    optionFilterProp="label"
                    maxTagCount="responsive"
                    filterOption={(input, option) =>
                      (option?.label ?? "")
                        .toLowerCase()
                        .includes(input.toLowerCase())
                    }
                    options={outlets.map((item) => ({
                      value: item.outlet_id,
                      label: item.outlet_name,
                    }))}
                  />
                </Form.Item>
              </Col>
            </Row>
          </Card>

          <Card
            title="Data Prize"
            extra={
              <Button type="primary" icon={<PlusOutlined />} onClick={addPrize}>
                Tambah Prize
              </Button>
            }
          >
            <Form.Item shouldUpdate>
              {() => {
                const prizes = form.getFieldValue("prizes") || [];

                const totalProbability = prizes.reduce(
                  (sum, item) => sum + Number(item.probability || 0),
                  0
                );

                return (
                  <>
                    <Alert
                      style={{ marginBottom: 16 }}
                      type={totalProbability === 100 ? "success" : "warning"}
                      message={`Total Probability: ${totalProbability.toFixed(
                        2
                      )}% | Sisa: ${(100 - totalProbability).toFixed(2)}%`}
                    />
                    <Table
                      rowKey={(_, index) => index}
                      pagination={false}
                      dataSource={prizes}
                      columns={[
                        {
                          title: "No",
                          width: 70,
                          render: (_, __, index) => index + 1,
                        },
                        {
                          title: "Gambar",
                          width: 100,
                          render: (_, record, index) =>
                            imagePreviews[index] ? (
                              <Image
                                src={imagePreviews[index]}
                                width={60}
                                height={60}
                                style={{
                                  objectFit: "cover",
                                  borderRadius: 8,
                                }}
                              />
                            ) : (
                              <div
                                style={{
                                  width: 60,
                                  height: 60,
                                  borderRadius: 8,
                                  background: "#f5f5f5",
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  color: "#999",
                                  fontSize: 12,
                                }}
                              >
                                No Image
                              </div>
                            ),
                        },
                        {
                          title: "Nama",
                          dataIndex: "name",
                          render: (text) => text || "-",
                        },
                        {
                          title: "Stock",
                          dataIndex: "stock",
                          width: 100,
                          render: (text) => text || 0,
                        },
                        {
                          title: "Probability",
                          dataIndex: "probability",
                          width: 130,
                          render: (text) => `${text || 0}%`,
                        },
                        {
                          title: "Status",
                          dataIndex: "is_active",
                          width: 120,
                          render: (text, record, index) => (
                            <Select
                              value={text}
                              style={{ width: 110 }}
                              onChange={(value) => {
                                const newPrizes = [...prizes];
                                newPrizes[index].is_active = value;
                                form.setFieldsValue({ prizes: newPrizes });
                              }}
                              options={[
                                { value: "true", label: "Aktif" },
                                { value: "false", label: "Nonaktif" },
                              ]}
                            />
                          ),
                        },
                        {
                          title: "Action",
                          width: 170,
                          render: (_, record, index) => (
                            <Space>
                              <Button
                                type="primary"
                                icon={<EyeOutlined />}
                                onClick={() => openPrizeDetail(index)}
                              >
                                Detail
                              </Button>

                              {prizes.length > 1 && (
                                <Button
                                  danger
                                  icon={<DeleteOutlined />}
                                  onClick={() => removePrize(index)}
                                />
                              )}
                            </Space>
                          ),
                        },
                      ]}
                    />
                  </>
                );
              }}
            </Form.Item>
          </Card>
        </Form>
      </Modal>

      <Modal
        title="Detail Prize"
        open={isPrizeModal}
        onOk={savePrizeDetail}
        onCancel={() => {
          setIsPrizeModal(false);
          setEditingPrizeIndex(null);
          prizeForm.resetFields();
        }}
        okText="Simpan Detail"
        cancelText="Batal"
        width={700}
        centered
      >
        <Form form={prizeForm} layout="vertical">
          <Row gutter={16}>
            <Col span={24}>
              <Form.Item name="prize_id" hidden>
                <Input />
              </Form.Item>
            </Col>

            <Col xs={24} md={12}>
              <Form.Item
                name="name"
                label="Nama Prize"
                rules={[{ required: true, message: "Nama prize wajib diisi!" }]}
              >
                <Input placeholder="Nama prize" />
              </Form.Item>
            </Col>

            <Col xs={24} md={12}>
              <Form.Item
                name="stock"
                label="Stock"
                rules={[{ required: true, message: "Stock wajib diisi!" }]}
              >
                <InputNumber style={{ width: "100%" }} min={0} precision={0} />
              </Form.Item>
            </Col>

            <Col xs={24} md={12}>
              <Form.Item
                name="price"
                label="Harga"
                rules={[{ required: true, message: "Harga wajib diisi!" }]}
              >
                <InputNumber
                  style={{ width: "100%" }}
                  min={0}
                  precision={2}
                  formatter={(value) =>
                    `Rp ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ".")
                  }
                  parser={(value) => value.replace(/Rp\s?|(\.*)/g, "")}
                />
              </Form.Item>
            </Col>

            <Col xs={24} md={12}>
              <Form.Item
                name="probability"
                label="Probability (%)"
                rules={[
                  {
                    required: true,
                    message: "Probability wajib diisi!",
                  },
                  ({ getFieldValue }) => ({
                    validator(_, value) {
                      const prizes = form.getFieldValue("prizes") || [];

                      const totalOther = prizes.reduce((sum, item, index) => {
                        if (index === editingPrizeIndex) return sum;
                        return sum + Number(item.probability || 0);
                      }, 0);

                      if (Number(value || 0) + totalOther > 100) {
                        return Promise.reject(
                          new Error(
                            `Maksimal tersisa ${(100 - totalOther).toFixed(2)}%`
                          )
                        );
                      }

                      return Promise.resolve();
                    },
                  }),
                ]}
              >
                <InputNumber
                  style={{ width: "100%" }}
                  min={0}
                  max={100}
                  precision={2}
                  step={0.01}
                  addonAfter="%"
                />
              </Form.Item>
            </Col>

            <Col xs={24} md={12}>
              <Form.Item
                name="is_active"
                label="Status"
                rules={[{ required: true, message: "Status wajib dipilih!" }]}
              >
                <Select
                  options={[
                    { value: "true", label: "Aktif" },
                    { value: "false", label: "Nonaktif" },
                  ]}
                />
              </Form.Item>
            </Col>

            <Col span={24}>
              <Form.Item name="description" label="Deskripsi Prize">
                <Input.TextArea rows={3} placeholder="Deskripsi prize" />
              </Form.Item>
            </Col>

            <Col span={24}>
              <Form.Item label="Gambar Prize">
                <Upload
                  listType="picture-card"
                  showUploadList={false}
                  beforeUpload={() => false}
                  onChange={(info) => uploadImage(info, editingPrizeIndex)}
                >
                  {imagePreviews[editingPrizeIndex] ? (
                    <img
                      src={imagePreviews[editingPrizeIndex]}
                      alt="prize"
                      style={{
                        width: 100,
                        height: 100,
                        objectFit: "cover",
                        borderRadius: 10,
                      }}
                    />
                  ) : (
                    uploadButton
                  )}
                </Upload>
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Modal>

      <Modal
        title="Detail Prize Category"
        open={isDetailModal}
        onCancel={() => setIsDetailModal(false)}
        footer={[
          <Button key="close" onClick={() => setIsDetailModal(false)}>
            Tutup
          </Button>,
        ]}
        width={900}
      >
        {detailData && (
          <>
            <Card>
              <h2>{detailData.name}</h2>
              <p>{detailData.description || "-"}</p>
              <Tag color={detailData.is_active ? "green" : "red"}>
                {detailData.is_active ? "Aktif" : "Nonaktif"}
              </Tag>
            </Card>

            <Divider orientation="left">Daftar Prize</Divider>

            {(detailData.prizes || detailData.Prizes || []).map((item) => (
              <Card
                key={item.prize_id}
                size="small"
                style={{ marginBottom: 12 }}
              >
                <Row gutter={16}>
                  <Col xs={24} md={5}>
                    <Image
                      src={item.image}
                      width={120}
                      height={120}
                      style={{
                        objectFit: "cover",
                        borderRadius: 12,
                      }}
                    />
                  </Col>

                  <Col xs={24} md={19}>
                    <h3>{item.name}</h3>
                    <p>{item.description || "-"}</p>

                    <Space wrap>
                      <Tag color="green">Stock: {item.stock}</Tag>
                      <Tag color="blue">Probability: {item.probability}%</Tag>
                      <Tag color="purple">
                        Harga: Rp{" "}
                        {Number(item.price || 0).toLocaleString("id-ID")}
                      </Tag>
                      <Tag color={item.is_active ? "green" : "red"}>
                        {item.is_active ? "Aktif" : "Nonaktif"}
                      </Tag>
                    </Space>
                  </Col>
                </Row>
              </Card>
            ))}
          </>
        )}
      </Modal>
    </>
  );
}

export default ListPrizeCategory;